import { Flex, Typography } from 'antd';
import {
  AnchorSimple,
  ArrowLeft,
  CheckCircle,
  Cube,
  ListNumbers,
} from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import type { WmsShipmentInboundType } from 'schemas/shipment/inbound/detail';
import { COLOR } from '@styles/theme';
import { INBOUND_SHIPMENTS_LIST } from '@utility/utils/shipment-display';
import {
  InboundDetailSteps,
  SecondaryHeaderBar,
  StepsCenter,
} from './inboundDetailStyled';

const { Text } = Typography;

const STEP_DEFS = [
  { title: 'Arrival', icon: <AnchorSimple size={14} /> },
  { title: 'Item Count', icon: <ListNumbers size={14} /> },
  { title: 'Storage Assignment', icon: <Cube size={14} /> },
  { title: 'Complete', icon: <CheckCircle size={14} /> },
] as const;

type InboundShipmentDetailHeaderProps = {
  data: WmsShipmentInboundType;
  stepIndex: number;
};

export function InboundShipmentDetailHeader({
  data,
  stepIndex,
}: InboundShipmentDetailHeaderProps) {
  const stepItems = STEP_DEFS.map(({ title, icon }, i) => {
    let stepStatus: 'wait' | 'process' | 'finish' | 'error' = 'wait';
    if (i < stepIndex) {
      stepStatus = 'finish';
    } else if (i === stepIndex) {
      stepStatus = 'process';
    }
    return { title, icon, status: stepStatus };
  });

  return (
    <SecondaryHeaderBar>
      <Link
        to={INBOUND_SHIPMENTS_LIST}
        style={{ position: 'relative', zIndex: 1, flexShrink: 0, textDecoration: 'none' }}
      >
        <Flex align="center" gap={6}>
          <ArrowLeft size={16} color={COLOR.black} />
          <Text style={{ fontSize: 14, color: COLOR.black }}>Back to Shipments</Text>
        </Flex>
      </Link>

      <StepsCenter>
        <InboundDetailSteps current={stepIndex} items={stepItems} />
      </StepsCenter>
    </SecondaryHeaderBar>
  );
}
